import React from "react";
import PathConstants from "./path-constants";

// Report Appeal Result Flow
const AppealWonPage = React.lazy(
  () => import("../pages/product/reporting-flow/appeal-won"),
);
const UploadApprovalLetterPage = React.lazy(
  () => import("../pages/product/reporting-flow/upload-approval-letter"),
);
const ReviewAndSharePage = React.lazy(
  () => import("../pages/product/reporting-flow/review-and-share"),
);
const DenialUpheldPage = React.lazy(
  () => import("../pages/product/reporting-flow/denial-upheld"),
);
const DenialUpheldClaimFilePage = React.lazy(
  () => import("../pages/product/reporting-flow/denial-upheld-claim-file"),
);
const AppealLostPage = React.lazy(
  () => import("../pages/product/reporting-flow/appeal-lost"),
);

const routes = [
  {
    path: PathConstants.AppealWon,
    element: <AppealWonPage />,
  },
  {
    path: PathConstants.UploadApprovalLetter,
    element: <UploadApprovalLetterPage />,
  },
  {
    path: PathConstants.ReviewAndShare,
    element: <ReviewAndSharePage />,
  },
  {
    path: PathConstants.DenialUpheld,
    element: <DenialUpheldPage />,
  },
  {
    path: PathConstants.DenialUpheldClaimFile,
    element: <DenialUpheldClaimFilePage />,
  },
  {
    path: PathConstants.AppealLost,
    element: <AppealLostPage />,
  },
];

export default routes;
